import { App, DirectiveBinding } from 'vue'
import { useUserStore } from '@/pinia/stores/user'

/**
 * 权限指令
 * 使用方式: v-permission="['admin', 'editor']"
 * 约定：需要 admin 时，superadmin 同样通过。
 */
function hasRequiredRole(requiredRoles: string[], userRoles: string[]): boolean {
  const normalizedUser = new Set(
    (userRoles || []).map((role) => String(role || '').trim().toLowerCase()).filter(Boolean)
  )
  return requiredRoles.some((role) => {
    const normalized = String(role || '').trim().toLowerCase()
    if (!normalized) return false
    if (normalizedUser.has(normalized)) return true
    return normalized === 'admin' && normalizedUser.has('superadmin')
  })
}

export function setupPermissionDirective(app: App) {
  app.directive('permission', {
    mounted(el: HTMLElement, binding: DirectiveBinding<string[]>) {
      const { value } = binding
      const userStore = useUserStore()

      if (value && value instanceof Array && value.length > 0) {
        if (!hasRequiredRole(value, userStore.roles)) {
          el.parentNode?.removeChild(el)
        }
      } else {
        throw new Error('权限指令需要传入角色数组，例如: v-permission="[\'admin\']"')
      }
    },
    updated(el: HTMLElement, binding: DirectiveBinding<string[]>) {
      const { value } = binding
      const userStore = useUserStore()

      if (value && value instanceof Array && value.length > 0) {
        if (!hasRequiredRole(value, userStore.roles) && el.parentNode) {
          el.parentNode.removeChild(el)
        }
      }
    }
  })
}

